import VisualizarTypes from "./types";

export const viewRequest = (id) => ({
  type: VisualizarTypes.VIEW_REQUEST,
  payload: { id }
});

export const viewSuccess = (dados) => ({
  type: VisualizarTypes.VIEW_PROTOCOLO,
  payload: dados
});

export const clear = () => ({
  type: VisualizarTypes.CLEAR
});
